import StaedteError from "./Error";

export default function CityFrontpage(params) {

    const cityFrontpageData = params.data;

    let errorOccured = undefined !== cityFrontpageData.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <>
                <StaedteError />
            </>
        );
    } else if ( undefined === cityFrontpageData || 0 === cityFrontpageData.length ) {
        return;
    }

    const citiesURL = `${window.location.protocol}//${window.location.hostname}/stadt?stadt=`;

    return(
        <>
            <div className="cities-frontpage-container">

                    {
                        cityFrontpageData.map(
                            (frontpageData, index) => {
                                return(
                                    <div className="cities-frontpage-row-container" key={index}>
                                        <div className="cities-frontpage-card-container">

                                            <a href={`${citiesURL}${frontpageData.city}`} className="text-decoration-none">
                                                <div className="cities-frontpage-city-link-part">
                                                    <img className="cities-frontpage-location-icon" alt="location-icon" src="https://www.bierbachelor.com/wp-content/plugins/Staedte/public/images/marker_grey.webp" />
                                                    <div>
                                                        <div className="cities-frontpage-information-container">
                                                            <div className="cities-frontpage-cityname">
                                                                {frontpageData.name}
                                                            </div>
                                                            {
                                                                
                                                                1 >= Number(frontpageData.endlocations) ?
                                                                    <div className="cities-frontpage-endlocations">
                                                                        {window.staedteFrontendShortcodeData.i18n.oneEndlocation}
                                                                    </div> :
                                                                    <div className="cities-frontpage-endlocations">
                                                                        {`${frontpageData.endlocations} ${window.staedteFrontendShortcodeData.i18n.endlocations}`}
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>

                                            {
                                                ( 1 === Number(frontpageData.ticketShopActive) ) ?
                                                    <a 
                                                        href={`${window.location.protocol}//${window.location.hostname}/tickets/${frontpageData.name}`} 
                                                        className="text-decoration-none"
                                                    >
                                                        <div className="cities-frontpage-buy-ticket-active-link-inner-wapper">

                                                            <div className="cities-frontpage-buy-tickets-img-container">

                                                                <img
                                                                    className="cities-frontpage-buy-tickets-img"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    alt="Zu den Tickets"
                                                                    src="https://www.bierbachelor.com/wp-content/plugins/Staedte/public/images/warenkorb.png"
                                                                />
                                                                <div style={{marginTop: "10px"}}>
                                                                    {window.staedteFrontendShortcodeData.i18n.ticketsUppercase}
                                                                </div>
                                                                <div style={{marginTop: "4px"}}>
                                                                    {window.staedteFrontendShortcodeData.i18n.saveUppercase}
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </a> :
                                                    <div>
                                                        <div className="cities-frontpage-buy-ticket-inactive-link-inner-wapper">
                                                            
                                                            <div className="cities-frontpage-buy-tickets-img-container">

                                                                <img
                                                                    className="cities-frontpage-buy-tickets-img"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    alt="Zu den Tickets"
                                                                    src="https://www.bierbachelor.com/wp-content/plugins/Staedte/public/images/warenkorb_grau.svg"
                                                                />
                                                                <div style={{marginTop: "10px"}}>
                                                                    {window.staedteFrontendShortcodeData.i18n.ticketsUppercase}
                                                                </div>
                                                                <div style={{marginTop: "4px"}}>
                                                                    {window.staedteFrontendShortcodeData.i18n.saveUppercase}
                                                                </div>

                                                            </div>
                                                            
                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                    </div>
                                );
                            }
                        )
                    }

                    <div className="cities-frontpage-last-card-container">

                        

                            <a
                                href={`${window.location.protocol}//${window.location.hostname}/kontakt`}
                                className="text-decoration-none cities-frontpage-last-card-wrapper"
                            >

                                <div>
                                    
                                    <div className="cities-frontpage-last-card-title">
                                        {window.staedteFrontendShortcodeData.i18n.missingCity}
                                    </div>

                                    <div className="cities-frontpage-last-card-text">
                                        {window.staedteFrontendShortcodeData.i18n.letUsKnow}
                                    </div>
                                
                                </div>
                                
                                <div className="cities-frontend-last-card-action-container">

                                    <div className="cities-frontend-last-card-action-inner-wrapper">
                                    
                                        <span
                                            className="dashicons dashicons-arrow-right-alt"
                                            style={{
                                                    color: "#3294a8"
                                            }}
                                        ></span>

                                        <div style={{marginTop: "10px"}}>
                                            {window.staedteFrontendShortcodeData.i18n.contactUppercase}
                                        </div>

                                        <div style={{marginTop: "4px"}}>
                                            {window.staedteFrontendShortcodeData.i18n.toUsUppercase}
                                        </div>

                                    </div>

                                </div>
                                
                            </a>

                       
                    </div>

                
            </div>
        </>
    );

}